import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneratorUsageService } from 'app/shared/services/generator-usage.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'ngx-generator-usage',
  templateUrl: './generator-usage.component.html',
  styleUrls: ['./generator-usage.component.scss']
})
export class GeneratorUsageComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  dataList =[];


  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  form: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  
  
  validationMessages = {
    'startDate' : { 'required': 'This field is required' },
    'startReading' : { 'required': 'This field is required' },
    'endDate' : { 'required': 'This field is required' },
    'endReading' : { 'required': 'This field is required' },
    'consumption' : { 'required': 'This field is required' },
  
  
  };

  formErrors = {
    'startDate' : "",
    'startReading' : "",
    'endDate' : "",
    'endReading' : "",
    'consumption' : "",

  };




    constructor(private fb: FormBuilder,
                private generatorUsageService: GeneratorUsageService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {

    this.form = this.fb.group({
      id : [null],
      startDate: ['',Validators.required],
      startReading: ['',Validators.required],
      endDate: ['',Validators.required],
      endReading: ['',Validators.required],
      consumption: ['',Validators.required],
      fuel: [''],
      createdBy: [''],



    });

  
   this.form.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.form);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='BR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }




  attachFileButtonClick(){
    this.fileUploadService.refNo = this.form.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.form.reset();
    this.enableForm();
    
   }

  


  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }



   calculateAmounts(){
    let consumption =null;

    if(this.form.value.startReading && 
      this.isNumeric(this.form.value.startReading) && 
      this.form.value.endReading && 
      this.isNumeric(this.form.value.endReading)){

        consumption = (this.form.value.endReading - this.form.value.startReading).toFixed(2);

    }

  
    this.form.patchValue({
      consumption :  consumption,
    });

   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.form,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.form.value.id){
                this.showProcessingIndicator = true;
                this.generatorUsageService.create(formData)
                .subscribe(
                  (res) => {
                                data=res;
                                this.toastr.success('Record added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                               

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.generatorUsageService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.form,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    let formData ={
      ...this.form.value,
      startDate : moment(this.form.value.startDate).format("YYYY-MM-DD"),
      endDate : moment(this.form.value.endDate).format("YYYY-MM-DD"),
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }
   



viewData(data){

  this.form.patchValue({
    id : data.Id,
    startDate:data.StartDate ?  moment(data.StartDate).format("YYYY-MM-DD"): null,
    startReading:data.StartReading,
    endDate:data.EndDate ?  moment(data.EndDate).format("YYYY-MM-DD"): null,
    endReading:data.EndReading,
    consumption:data.Consumption,
    fuel:data.Fuel,
    createdBy:data.CreatedBy,

   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.generatorUsageService.dataRow;
  if(data){
    this.viewData(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

}//end class



